export default "/8522fe2631ecefb1e3967be9883671f05392a386/20e765fe22790b7f1075e229233d4cab.svg";